export default function Footer() {
    return (
        <footer className="container mt-auto pt-3">
            <div id="footerText" className="container d-flex justify-content-center ">
                <p className="text-white-50 px-4">Last updated on Jan 2025 by <a href="https://github.com/ela-codes" className="text-white-50">ela-codes</a>.</p>
                
            </div>
        </footer>
    );
}